export default __webpack_public_path__ + "static/media/cautaredosare3.5bb00c64.png";